import { Box, InputLabel } from "@mui/material";
import React from "react";

import { TextInput } from "components/common/TextInput";
import { DEFAULT_MAX_COUNT } from "config/constants";
import { Typography } from "new-components/typography/Typography";

interface CountDetectorDetailSettingsProps {
  maxCount: number | null | undefined;
  countingObjectClass: string | undefined;
}

export function CountDetectorDetailSettings(props: CountDetectorDetailSettingsProps) {
  const { maxCount, countingObjectClass } = props;

  return (
    <>
      <Typography fontWeight="bold" textTransform="uppercase" className="text-neutral-medium mb-2">
        Answer Options:
      </Typography>
      <Box className="flex flex-col gap-4">
        <Box>
          <InputLabel className="uppercase text-sm text-neutral-700 font-bold mb-2">
            Object Name
          </InputLabel>
          <TextInput value={countingObjectClass} disabled fullWidth />
        </Box>
        <Box>
          <InputLabel className="uppercase text-sm text-neutral-700 font-bold mb-2">
            Maximum Count Per Image
          </InputLabel>
          <TextInput value={maxCount || DEFAULT_MAX_COUNT} disabled fullWidth />
        </Box>
      </Box>
    </>
  );
}
